import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { costOfInaction } from '../data/content';
import { toneAt } from '../utils/iconTones';
import { Accent, SectionHeading } from './SectionHeading';
export function CostSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="costo-titulo" data-id="element-17" data-mp="4jdduntbtbge">
      <div className="mx-auto max-w-5xl" data-id="element-18" data-mp="3vr921oibmsvk">
        <SectionHeading id="costo-titulo" badge="El costo de no tenerlo" badgeIcon={AlertTriangleIcon} title={<>
              Sin el Kit Instrumentación Industrial <Accent data-id="element-20" data-mp="3mpjb0jscpvyb">perdés:</Accent>
            </>} data-id="element-19" data-mp="3qs6a95rcqj5j" />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-21" data-mp="3hr82qdhpfti7">
          {costOfInaction.map(({
          icon: Icon,
          title,
          description
        }, index) => <li key={title} className="flex h-full flex-col rounded-xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-22" data-mp="1g0d298cjz655" data-mpi={index}>
              <span className={`flex h-7 w-7 items-center justify-center rounded-lg ${toneAt(index + 2).bg}`} data-id="element-23" data-mp="1b0s593gy17v2">
                <Icon className={`h-3.5 w-3.5 ${toneAt(index + 2).fg}`} aria-hidden="true" data-id="element-24" data-mp="p7bn19nl80i6" />
              </span>
              <h3 className="mt-3 text-sm font-semibold leading-tight text-forest-800" data-id="element-25" data-mp="ta83atpnnkiy">{title}</h3>
              <p className="mt-2 text-[0.8rem] leading-relaxed text-forest-700/85" data-id="element-26" data-mp="fafb0tyhcw8v">{description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}